import { useAccordion } from '../../../customHook.js/useAccordion'
import useScrollAnimation from '../../../customHook.js/useScrollAnimation'

import { highlightText } from '../../../helpers/helperFunctions'
import chair from '../../../images/chair.jpg'
import {
  workingInSpace1,
  workingInSpace2,
  workingInSpace3,
} from '../../../const/contentData'
import RenderContent from '../../../helpers/RenderContent'
import modelRTL from '../../../const/modelRTL'
import openingParagraph from '../../../const/openingParagraph'
import classes from '../content.module.css'

function WorkingInSpace({ searchTerm, handleScrollToSection }) {
  const moduleName = 'workingInSpace'

  const { selectedRow, highlightedText, changeSelectedRow } = useAccordion(
    moduleName,
    searchTerm,
    0
  )
  const getToContainer = useScrollAnimation(moduleName)

  return (
    <div
      className={`${classes.main_container} ${
        !modelRTL[moduleName] && 'row_reverse'
      }`}
      id={moduleName}
    >
      <div
        className={`${classes.text_area} ${
          modelRTL[moduleName] ? classes.hidden_left : classes.hidden_right
        } ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <p className="fw_500">
          {highlightText(openingParagraph.workingInSpace[0], highlightedText)}
        </p>
        <p className="fw_700">
          {highlightText(openingParagraph.workingInSpace[1], highlightedText)}
        </p>
        <div className={classes.drop_down_section}>
          <div className="c_blue">
            <p className={classes.floor}>קומה</p>
            <p className={classes.number}>08</p>
          </div>
          <div>
            {workingInSpace1.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title}  ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                </div>
              </div>
            ))}
            <p className="fw_500">
              בקומה גם אולם הדרכה נוסף, חדרי ראיונות וחדר בריאות ויופי,
              <a
                className="c_pink pointer"
                onClick={() => {
                  handleScrollToSection('health', 1)
                }}
              >
                &nbsp; לחצו לקרוא עוד
              </a>
            </p>
          </div>
        </div>
        <hr className={classes.divider} />
        <div className={classes.drop_down_section}>
          <div className="c_blue">
            <p className={classes.floor}>קומה</p>
            <p className={classes.number}>09</p>
          </div>
          <div>
            {workingInSpace2.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title} ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <hr className={classes.divider} />
        <div className={classes.drop_down_section}>
          <div>
            {workingInSpace3.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title} ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`${classes.main_img_container} ${
          modelRTL[moduleName] ? classes.hidden_right : classes.hidden_left
        }  ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <img src={chair} alt="chair" />
        <div>
          <h2>עובדים</h2>
          <h2>בחלל</h2>
        </div>
      </div>
    </div>
  )
}

export default WorkingInSpace
